import { type ReactNode } from 'react'

import { LoadingMask } from '@/components/common/LoadingMask'
import { OptionCount } from '@/components/common/OptionCount'
import { Icon } from '@/components/icons/Icon'
import { type IconType } from '@/defs/icon'
import { type WiggleType } from '@/defs/input'
import { type DistributiveOmit } from '@/defs/misc'
import { cn } from '@/utils/commonUtil'

import { ButtonRoot, type Props as RootProps } from '../ButtonRoot/ButtonRoot'

import styles from './ButtonCheckbox.module.scss'

type BaseProps = {
  borderColor?: 'warning'
  checkNone?: boolean
  children?: ReactNode
  count?: number
  icon?: IconType
  selected?: boolean
  showLoadingMask?: boolean
  size?: 'sm' | 'lg'
  variant?: 'stacked' | 'simple'
  wiggle?: WiggleType
  wrap?: boolean
}

type Props = BaseProps & DistributiveOmit<RootProps, keyof BaseProps | 'className'>

export const ButtonCheckbox = ({
  borderColor,
  checkNone,
  children,
  count,
  icon,
  selected,
  showLoadingMask,
  size,
  variant,
  wiggle,
  wrap,
  ...props
}: Props) => (
  <ButtonRoot
    {...props}
    className={cn(styles.container, {
      borderColor,
      selected,
      size,
      styles,
      variant,
      wiggle,
      wrap,
    })}
  >
    {!checkNone && (
      <span className={styles.check}>
        <span className={styles.iconCheck}>
          <Icon name={icon || 'check'} />
        </span>
      </span>
    )}
    <span className={styles.label}>{children}</span>
    {count !== undefined && (
      <span className={styles.count}>
        <OptionCount count={count} />
      </span>
    )}
    <LoadingMask loading={showLoadingMask} />
  </ButtonRoot>
)
